import { render } from "./SelectedCarouselImage.vue?vue&type=template&id=6ebfdc01&scoped=true"
import script from "./SelectedCarouselImage.vue?vue&type=script&lang=js"
export * from "./SelectedCarouselImage.vue?vue&type=script&lang=js"

import "./SelectedCarouselImage.vue?vue&type=style&index=0&id=6ebfdc01&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebfdc01"]])

export default __exports__